import MapNavButton from '@locus-labs/mol-desktop-map-nav-button'
import Tooltip from '@locus-labs/mol-desktop-tooltip'
import React from 'react'
import { withTheme } from 'styled-components'

// visual component reflects `isHome` state - which is true when user map
// is centered on the pinned location
const ReturnButtonDesktop = withTheme(({ isHome, onClick, theme, T }) => {
  return (
    <Tooltip
      content={T('pinnedLocation:Return To Pinned Location')}
      data-cy='PinnedLocationReturnTooltip'
    >
      <MapNavButton data-cy="pinnedLocationReturnButton" iconName="my.location.arrow" onClick={onClick} ariaLabel={T('pinnedLocation:Return To Pinned Location')} />
    </Tooltip>
  )
})

export default ReturnButtonDesktop
